import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantService } from '../../../../../../Services';
import { Field, ValueIsProperty } from '../../../Models';
import { ValueTextItem } from '../../../Models/ModuleDefinitions/ValueTextItem';
import { ModuleService } from '../../../Services/module.service';

@Injectable({
    providedIn: 'root'
})
export class AvailabilityService {
    canSave: boolean;
    conditions: ValueIsProperty[];
    conditionFields: Field[];
    listItemsCache: ValueTextItem[][] = [];

    constructor(
        private moduleService: ModuleService,
        private tenantService: TenantService
    ) { }

    getConditionFields(selectedStepId: string): void {
        this.conditionFields = this.moduleService.getModuleFieldsForPreviousSteps(selectedStepId);
    }

    setExistingConditions(existingConditions: ValueIsProperty[]): void {
        this.conditions = [];
        if (existingConditions) {
            existingConditions.forEach(c => {
                let existingCondition: ValueIsProperty = {
                    PropertyName: c.PropertyName,
                    ValueIs: {
                        Identifier: c.ValueIs.Identifier,
                        Value: c.ValueIs.Value
                    }
                }
                this.conditions.push(existingCondition);
            });
        }
    }

    addCondition(): void {
        let newCondition: ValueIsProperty = {
            PropertyName: "",
            ValueIs: {
                Identifier: "",
                Value: undefined
            }
        };
        this.conditions.push(newCondition);
        this.canSave = true;
    }

    deleteCondition(index: number): void {
        this.conditions.splice(index, 1);
        this.canSave = true;
    }

    validateConditions(): boolean {
        if (!this.conditions) {
            return false;
        }
        let isValid: boolean = true;
        this.conditions.forEach(condition => {
            if (!condition.PropertyName || !condition.ValueIs) {
                isValid = false;
            }
            if (!condition.ValueIs.Identifier || !condition.ValueIs.Value) {
                isValid = false;
            }
        });
        return isValid;
    }

    async saveConditions(versionNumber: number) {
        this.canSave = false;
       
        await this.moduleService.updateFieldBasedAvailability(
            this.conditions,
            this.tenantService.selectedTenant,
            this.moduleService.moduleContent.ModuleId,
            versionNumber,
            this.moduleService.selectedStep.StepId,
            this.moduleService.selectedStep.StepName
        ).toPromise();

        await this.moduleService.applyPatch(
            this.tenantService.selectedTenant,
            this.moduleService.moduleContent.ModuleId,
            [{
                Operation: 'Upsert',
                Parameters: {
                    PropertyName: 'FieldBasedAvailability',
                    Value: this.conditions
                },
                PropertyPaths: [['Steps', this.moduleService.selectedStep.StepId]]
            }]
        );
    }

    getListItems(listName: string): Observable<ValueTextItem[]> {
        const cacheVal = this.listItemsCache[listName];
        if (cacheVal) {
            return of(cacheVal);
        } else {
            return this.tenantService.getListItems(["AIRSWEBLIST", listName]).pipe(
                map(result => {
                    let values: ValueTextItem[] = [];
                    result.forEach(r => {
                        let value: ValueTextItem = {
                            Text: r.Text,
                            Value: r.Value
                        };
                        values.push(value);
                    });
                    this.listItemsCache[listName] = values;
                    return values;
                })
                )
        }
    }

    prettifyLabel(lbl: string): string {
        let op: string;
        if (!lbl) {
            console.log("label undefined");
            return "";
        }
        if (lbl.indexOf(":") > -1) {
            op = lbl.split(":")[1];
        } else {
            op = lbl;
        }

        return op.replace(/_/g, " ");
    }
}
